<template>
  <div id="hello-world">
    <div class="container">
      <h1>Lore to come...</h1>
      <img class="img-responsive" src="https://firebasestorage.googleapis.com/v0/b/lore-eights.appspot.com/o/sketches%2F2019%2F03%2FIMG_5592.JPG?alt=media&token=4f720f61-f7b4-4b18-aafd-44ee2ba694bd">
    </div><!-- /.container -->
  </div><!-- /#helloWorld -->
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style scoped>
  #hello-world {
    text-align: center;
  }

  #hello-world img {
    max-width: 400px;
    border-radius: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue